var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{attrs:{"to":{name: 'composerById', params: { locale: _vm.$i18n.localePath(), id: _vm.composer.id }},"title":_vm.displayComposerName(_vm.composer)}},[_vm._v("\n  "+_vm._s(_vm.displayComposerName(_vm.composer))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }